import Icon from "./Icon";
import IconLabel from "./IconLabel";

export { Icon, IconLabel };
export default Icon;



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/Icons/index.js